var React = require('react');

function PinActiveInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M33.622 0.984375C20.2423 0.984375 9.35718 11.8695 9.35718 25.2491C9.35718 41.8536 31.0719 66.2299 31.9964 67.2595C32.8648 68.2267 34.3809 68.225 35.2477 67.2595C36.1722 66.2299 57.8869 41.8536 57.8869 25.2491C57.8866 11.8695 47.0016 0.984375 33.622 0.984375ZM33.622 37.4574C26.8904 37.4574 21.4139 31.9808 21.4139 25.2491C21.4139 18.5174 26.8905 13.041 33.622 13.041C40.3536 13.041 45.83 18.5176 45.83 25.2492C45.83 31.9809 40.3536 37.4574 33.622 37.4574Z","fill":"#BD1622"})),React.createElement("defs",{"key":1},React.createElement("clipPath",null,React.createElement("rect",{"width":"67","height":"67","fill":"white","transform":"translate(0.121948 0.984375)"})))]);
}

PinActiveInline.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = PinActiveInline;

PinActiveInline.default = PinActiveInline;
